import React from 'react';
import QuestionBlock from '../components/c-create-question';
export default (props) => (
  <QuestionBlock
    {...props}
    ReadMoreText={props.CurrentPageProps.Content.Translations.readmore}
    ReadLessText={props.CurrentPageProps.Content.Translations.readless}
  />
);
